import { Helmet } from "react-helmet-async";
import { useLocale } from "../hooks/useLocale";

const CANONICAL_URL = "https://capcut-srt.nubelnk.cloud/";
const OG_IMAGE = `${CANONICAL_URL}/og-image.png`;

export function SEOHead() {
  const { t } = useLocale();

  const title = t("seo.title");
  const description = t("seo.description");

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "CapCut SRT",
    description,
    applicationCategory: "MultimediaApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    browserRequirements: "Requires JavaScript",
  };

  return (
    <Helmet>
      {/* Primary meta */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />

      {/* Canonical */}
      <link rel="canonical" href={CANONICAL_URL} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={CANONICAL_URL} />
      <meta property="og:image" content={OG_IMAGE} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
